/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

// required attributes
const DettaglioR = t.interface({});

// optional attributes
const DettaglioO = t.partial({
  CCP: t.string,

  IUV: t.string,

  codicePagatore: t.string,

  enteBeneficiario: t.string,

  idDominio: t.string,

  idPayment: t.string,

  importo: t.number,

  nomePagatore: t.string,

  tipoPagatore: t.string
});

export const Dettaglio = t.intersection([DettaglioR, DettaglioO], "Dettaglio");

export type Dettaglio = t.TypeOf<typeof Dettaglio>;
